// hooks/useFilterHandlers.js
import { useCallback } from "react";
import { transformFiltersForUrl } from "../utils/transformFiltersForUrl";

const useFilterHandlers = (applyUrlFilters, fieldConfig = {}) => {
  const handleFilterApply = useCallback(
    (currentLocalFilterValues) => {
      const transformed = transformFiltersForUrl(
        currentLocalFilterValues,
        fieldConfig,
      );
      applyUrlFilters(transformed);
    },
    [applyUrlFilters, fieldConfig],
  );

  const handleFilterClear = useCallback(
    (initialLocalFilterStateFromHook) => {
      const transformedInitial = transformFiltersForUrl(
        initialLocalFilterStateFromHook,
        fieldConfig,
      );
      applyUrlFilters(transformedInitial);
    },
    [applyUrlFilters, fieldConfig],
  );

  return { handleFilterApply, handleFilterClear };
};

export default useFilterHandlers;
